import React from 'react';
import { format } from "date-fns";
import { constructDetailUrl } from '../../../utils/constants/urls';

export default (props) => {
	const {
            formResults,
            totalhits,
            wellURL,
            show_start,
            show_end,
        } = props;

    if (formResults != null){
        if ( Object.keys( formResults ).length && formResults.length){
            return (
                <div>
                    <div className="counter">
                        <p className="counter_text">{totalhits} job(s)</p>
                    </div>
                    <div className="results_container">
                        {formResults.map( (formResults, idx) => {
                            return (
                                <div key={  idx }>
                                    <div className="wells_card">
                                        <h2 className="well_card_header"><a className="well_link" href={constructDetailUrl(formResults.APINumber)}>{ formResults.WellName}</a></h2>
                                        <a href={constructDetailUrl(formResults.APINumber)}>
                                            <button className="wells_button">Disclosure(s)</button>
                                        </a><br />
                                        <div className="wells_header">
                                            <p className="wellcard_oper" title="Operator means the individual, company, trust, or foundation responsible for the exploration, development, and production of an oil or gas well or lease.">Operated by&nbsp;</p>
                                            <p className="wellcard_oper_param">{formResults.OperatorClean}</p>
                                        </div>
                                        <table className="wells_location_card"> 
                                            <tbody>
                                                <tr className="location_block"><td>API<span className="param_result">{formResults.APINumber}</span></td></tr>
                                                <tr className="location_block"><td>State<span className="param_result">{formResults.StateName}</span></td></tr>
                                                <tr className="location_block"><td>County<span className="param_result">{formResults.CountyName}</span></td></tr>
                                                <tr className="location_block"><td>Job End Date<span className="param_result">{format(new Date(formResults.JobEndDate),'MMMM do Y')}</span></td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )
                        })}
                        

                    </div>
                    <div className="advanced_footnote">
                        <p>The Chemical Abstracts Service data provided by operators is not normalized, therefore the results displayed may not be complete when searching by CAS Numbers.
                            Searching for CAS Numbers will not return disclosures entered using the MSDS+ entry method, but CAS information is available in the PDF downloads.
                            The map search returns, at max, 30,000 results. Zoom in to view more results.
                        </p>
                    </div>
                </div>
            )
        }
        else if ( formResults.length === 0 ){
            return (
                <div className="wells_in_region">
                    <div className="well_count_text">
                        <br />
                        <p>No results for this area</p>
                    </div>
                </div>
            )
        }
        else {
            return('')
        }
    }
}


